import React from 'react';

const items = [
  { title: 'KvK-nummer registratie', desc: 'Automatische opname van jouw KvK-nummer conform de vereisten van de Kamer van Koophandel' },
  { title: 'BTW-nummer (btw-nummer)', desc: 'Correcte vermelding van jouw btw-nummer conform de Nederlandse Wet op de Omzetbelasting' },
  { title: 'Nederlands burgerlijk recht', desc: 'Clausules conform het Burgerlijk Wetboek (BW) en de Wet DBA voor ZZP\'ers' },
  { title: 'Betalingsvoorwaarden', desc: 'Facturatieritme, betalingstermijnen en wettelijke handelsrente conform de Wet Betalingstermijnen' },
  { title: 'Intellectueel eigendom', desc: 'Overdracht van auteursrechten conform de Nederlandse Auteurswet' },
  { title: 'Geheimhouding (NDA)', desc: 'Geheimhoudingsclausule beschermt vertrouwelijke informatie van de opdrachtgever' },
  { title: 'Aansprakelijkheidsbeperking', desc: 'Beperking van aansprakelijkheid conform het Nederlands contractenrecht' },
  { title: 'Bevoegde rechtbank', desc: 'Toepasselijk Nederlands recht en bevoegde Nederlandse rechtbank bij geschillen' },
];

const NetherlandsContractContents = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Wat bevat dit ZZP contract template voor Nederland?</h2>
    <ul className="space-y-3">
      {items?.map((item, i) => (
        <li key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
          <span className="flex-shrink-0 w-6 h-6 bg-[#FF8C00] rounded-full flex items-center justify-center mt-0.5">
            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </span>
          <div>
            <span className="font-semibold text-[#2F4E6F]">{item?.title}:</span>{' '}
            <span className="text-gray-600">{item?.desc}</span>
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export default NetherlandsContractContents;
